import { ORDEM, PICOS, SIGLAS, duracao, faixas, hm, totalMin } from "../lib/horarios";

const pct = (m) => `${((m / 1440) * 100).toFixed(3)}%`;
const MARCAS = [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22];
const ALTURA = "h-[540px]";

// Faixas de pico (almoço e jantar) atrás dos horários
const Picos = () => PICOS.map((p) => (
  <div key={p.nome} title={`Pico do ${p.nome}`} className="absolute inset-x-0 z-[1] pointer-events-none bg-amber-500/[0.07]"
    style={{ top: pct(p.de * 60), height: pct((p.ate - p.de) * 60) }} />
));

/**
 * A semana em colunas de 00:00 a 23:59: cada faixa aberta é um bloco na cor da
 * loja; dia fechado fica cinza. Clicar num dia abre a edição dele, e com algum
 * dia em edição os outros ficam apagados.
 */
export default function GradeSemana({ dias, editando, onEditar }) {
  const porDw = Object.fromEntries(dias.map((d) => [d.dw, d]));
  const foco = editando.size > 0;
  const apagado = (dw) => (foco && !editando.has(dw) ? "opacity-40" : "");
  return (
    <div className="rounded-xl bg-card p-2.5 pb-3 min-w-0" data-e2e="grade-semana">
      <div className="flex flex-wrap gap-4 pl-[42px] pb-2.5 text-xs text-muted-foreground">
        <span className="flex items-center gap-1.5"><i className="inline-block w-3.5 h-2.5 rounded-sm bg-primary/15 border border-primary/40" />Aberta</span>
        <span className="flex items-center gap-1.5"><i className="inline-block w-3.5 h-2.5 rounded-sm bg-amber-500/10 border border-amber-500/40" />Pico do almoço (11h às 15h) e do jantar (18h às 23h)</span>
      </div>
      <div className="overflow-x-auto sm:overflow-visible">
        <div className="grid grid-cols-[38px_repeat(7,minmax(0,1fr))] gap-x-1 min-w-[560px] sm:min-w-0">
          <div />
          {ORDEM.map((dw) => {
            const t = totalMin(faixas(porDw[dw]));
            const on = editando.has(dw);
            return (
              <button key={dw} type="button" onClick={() => onEditar(dw)} data-e2e={`grade-cab-${SIGLAS[dw]}`}
                className={`text-center pt-1.5 pb-3.5 transition-opacity ${on ? "bg-foreground text-background rounded-t-lg" : apagado(dw)}`}>
                <b className="block text-sm font-semibold">{SIGLAS[dw]}</b>
                <small className={`block text-[11px] mt-0.5 ${on ? "opacity-80" : t ? "text-primary" : "text-muted-foreground"}`}>
                  {t ? `Aberta por ${duracao(t)}` : "Fechada"}
                </small>
              </button>
            );
          })}

          <div className={`relative ${ALTURA}`}>
            {MARCAS.map((h) => <span key={h} className="absolute right-1.5 -translate-y-1/2 text-[10.5px] text-muted-foreground" style={{ top: `${(h / 24) * 100 + 1}%` }}>{h}h</span>)}
            <span className="absolute right-1.5 -translate-y-1/2 text-[10.5px] text-muted-foreground" style={{ top: "99%" }}>23:59</span>
            {PICOS.map((p) => <div key={p.nome} className="absolute right-0 w-0.5 rounded bg-amber-500/40" style={{ top: pct(p.de * 60), height: pct((p.ate - p.de) * 60) }} />)}
          </div>

          {ORDEM.map((dw) => {
            const dia = porDw[dw];
            const f = faixas(dia);
            const on = editando.has(dw);
            const anel = on ? "ring-2 ring-foreground rounded-b-md" : "";
            if (!f.length) {
              return (
                <div key={dw} onClick={() => onEditar(dw)} className={`relative ${ALTURA} bg-muted cursor-pointer transition-opacity ${anel} ${apagado(dw)}`} data-e2e={`grade-col-${SIGLAS[dw]}`}>
                  <span className="absolute top-2.5 left-2 z-[2] text-[11px] text-muted-foreground">Loja Fechada</span>
                  <Picos />
                </div>
              );
            }
            return (
              <div key={dw} className={`relative ${ALTURA} transition-opacity ${anel} ${apagado(dw)}`} data-e2e={`grade-col-${SIGLAS[dw]}`}>
                <Picos />
                {Array.from({ length: 12 }, (_, k) => (
                  <div key={k} className="absolute inset-x-0 rounded-[3px] bg-muted" style={{ top: `calc(${pct(k * 120)} + 2px)`, height: `calc(${pct(120)} - 4px)` }} />
                ))}
                {f.map(([s, e]) => (
                  // Fundo opaco (bg-card) com o tom da loja por cima: a grade de fundo não aparece através do bloco
                  <button key={s} type="button" onClick={() => onEditar(dw)} data-e2e="bloco-horario"
                    className="absolute inset-x-0 z-[2] overflow-hidden rounded-[3px] bg-card text-left hover:outline hover:outline-1 hover:outline-primary/50"
                    style={{ top: pct(s), height: pct(e - s) }}>
                    <span className="absolute inset-0 flex flex-col items-start justify-start bg-primary/20 border-l-2 border-primary px-2 py-1.5 text-[11px] font-medium text-primary whitespace-nowrap overflow-hidden">
                      <span className="max-w-full truncate">{hm(s)} - {hm(e)}</span>
                      {e - s >= 90 && <span className="text-[15px] font-bold tracking-tight mt-0.5">{e - s >= 1439 ? "24h" : duracao(e - s)}</span>}
                    </span>
                  </button>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
